<template>
  <div class="content">
    <FloatingCard>
      <p><strong>Document Manager má rád Flexi!</strong> Propojte Document Manager
        s účetním systémem ABRA Flexi, importujte přijaté faktury a ušetřete si práci.</p>
      <p>Pokud o integraci máte zájem, kontaktujte nás na
        <a href="mailto:care@cloudaper.com">care@cloudaper.com</a>.</p>
      <p>Pokud už jsme domluveni, můžete pokračovat v nastavení integrace kliknutím
        na tlačítko níže. Nebojte, zabere to jen pár minut.</p>
      <div class="flex flex--horizontal flex--justify-center">
        <ButtonComponent
          tag="a"
          label="Nastavit integraci"
          href="/nastaveni"
          @click="$router.push('nastaveni')"
        />
      </div>
    </FloatingCard>
  </div>
</template>

<script>
import FloatingCard from '@/components/FloatingCard';
import ButtonComponent from '@/components/ButtonComponent';

export default {
  name: 'Start',
  components: {
    FloatingCard,
    ButtonComponent,
  },
};
</script>
